import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Avatar, Box, Card, CardContent, Container, Grid, IconButton, Stack, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import SectionHeading from '../../components/Common/SectionHeading';
import { pageContent, teamMembers } from '../../data/siteData';

function TeamPage() {
  const content = pageContent.teamPage;

  return (
    <Box sx={{ bgcolor: '#fdfbf7' }}>
      <PageBanner {...content.banner} />
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <SectionHeading
          eyebrow={content.heading.eyebrow}
          title={content.heading.title}
          subtitle={content.heading.subtitle}
        />
        <Grid container spacing={3}>
          {teamMembers.map((member) => (
            <Grid item xs={12} sm={6} lg={3} key={member.email}>
              <Card elevation={0} sx={{ height: '100%' }}>
                <CardContent sx={{ p: 3 }}>
                  <Avatar sx={{ width: 72, height: 72, bgcolor: '#c9a84c', color: '#ffffff', fontWeight: 900, mb: 2 }}>
                    {member.initials}
                  </Avatar>
                  <Typography variant="h4">{member.name}</Typography>
                  <Typography sx={{ color: '#c9a84c', fontWeight: 800, mb: 1.5 }}>{member.role}</Typography>
                  <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 2 }}>{member.bio}</Typography>
                  <Stack direction="row" spacing={1}>
                    <IconButton component="a" href={member.linkedin} target="_blank" rel="noreferrer" sx={{ color: '#4a0e8f', bgcolor: '#f1e8ff' }}>
                      <LinkedInIcon />
                    </IconButton>
                    <IconButton component="a" href={`mailto:${member.email}`} sx={{ color: '#c9a84c', bgcolor: '#fff6de' }}>
                      <EmailRoundedIcon />
                    </IconButton>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default TeamPage;
